<template>
    <span>
        <base-button
            v-if="!textLink && !navLink && !arrowLink && !utilityNavLink"
            v-bind="$attrs"
            :text="btnFields ? btnFields.label : ''"
            :inverted="btnFields && btnFields.backgroundColor ? false : inverted"
            :color="btnFields && btnFields.backgroundColor ? backgroundColorClass(btnFields.backgroundColor) : undefined"
            :exact-active-class="
                siteConfig && siteConfig.secondaryColor === 'dark blue'
                    ? 'router-link-active-info'
                    : 'router-link-active-secondary'
            "
            @mouseover.native="isHover = true"
            @mouseleave.native="isHover = false"
            @click="handleClick"
        >
        </base-button>
        <router-link
            v-else
            :to="internalRoute"
            :exact-active-class="
                siteConfig && siteConfig.secondaryColor === 'dark blue'
                    ? 'router-link-active-info'
                    : 'router-link-active-secondary'
            "
            @click.native="$event.preventDefault()"
            @mouseover.native="isHover = true"
            @mouseleave.native="isHover = false"
            @focus.native="isHover = true"
            @blur.native="isHover = false"
        >
            <a
                v-if="textLink"
                class="link clickable"
                @click="handleClick"
            >
                <span class="text-underline">{{
                    btnFields ? btnFields.label : ''
                }}</span>
            </a>
            <v-btn
                v-if="arrowLink"
                :ripple="false"
                text
                role="link"
                class="hover-icon-right arrow-link-depth"
                @click="handleClick"
                @focus.native="isHover = true"
                @blur.native="isHover = false"
            >
                <span
                    class="primary--text"
                    style="font-size: 18px;font-weight: bold;text-transform: none !important;"
                    >
                  {{ btnFields ? btnFields.label : '' }}
                </span
                >
                <v-icon color="accent" postfix> arrow_forward </v-icon>
            </v-btn>
            <v-list-item
                v-if="navLink && btnFields && !btnFields.dropdownContent"
                :class="margin ? 'mx-md-5 mx-sm-2 mb-0 pa-0 clickable' : 'mx-md-2 mx-sm-1 mb-0 pa-0 clickable'"
                :ripple="false"
                @click="handleClick"
                :role="false"
            >
                <span
                    class="d-flex align-center pa-1"
                    :style="{ 'font-size': smAndDown ? '24px' : '16px' }"
                    :class="[
                        { 'primary--text': !isHover && !smAndDown },
                        mobileClass,
                        hoverClass
                    ]"
                >
                    {{ btnFields ? btnFields.label : '' }}
                    <v-icon v-if="smAndDown" color="primary"
                        >chevron_right</v-icon
                    >
                </span>
            </v-list-item>
            <v-list-item
                v-if="navLink && btnFields && btnFields.dropdownContent && !smAndDown"
                :class="margin ? 'mx-md-5 mx-sm-2 mb-0 pa-0 clickable' : 'mx-md-2 mx-sm-1 mb-0 pa-0 clickable'"
                :ripple="false"
                @click="handleClick"
                :role="false"
            >
                <span
                    class="d-flex align-center pa-1"
                    :style="{ 'font-size': smAndDown ? '24px' : '16px' }"
                    :class="[
                        { 'primary--text': !isHover && !smAndDown },
                        mobileClass,
                        hoverClass
                    ]"
                >
                    {{ btnFields ? btnFields.label : '' }}
                    <v-icon v-if="smAndDown" color="primary"
                        >chevron_right</v-icon
                    >
                </span>
            </v-list-item>
            <span
                v-if="utilityNavLink"
                class="ctf-utility-nav-link mb-0 dark-gray--text clickable"
                @click="handleClick"
            >
                {{ btnFields ? btnFields.label : '' }}
            </span>
        </router-link>
        <v-list-group
          v-if="navLink && btnFields && btnFields.dropdownContent && smAndDown"
          :value="false"
          :no-action="true"
          >
          <template v-slot:activator>
            <v-list-item-title>
              <span
                class="d-flex align-center pa-1"
                :style="{ 'font-size': smAndDown ? '24px' : '16px' }"
                :class="[
                    { 'primary--text': !isHover && !smAndDown },
                    mobileClass,
                    hoverClass
                ]"
              >
                {{btnFields.label}}
              </span>
            </v-list-item-title>
        </template>

          <v-list-item
            v-for="(i) in btnFields.dropdownContent"
            :key = "'nav-child-link-' + i.label"
            class="sub-router-link"
            >
            <router-link
              :to="replaceSpaceWithDash(i.internalLink)"
              :exact-active-class="
                  siteConfig && siteConfig.secondaryColor === 'dark blue'
                      ? 'router-link-active-info'
                      : 'router-link-active-secondary'
              "
              @click.native="$event.preventDefault()"
              >
              <span
                class="d-flex align-center pa-1"
                :style="{ 'font-size': smAndDown ? '24px' : '16px' }"
                :class="[
                    { 'primary--text': !isHover && !smAndDown },
                    mobileClass,
                    hoverClass
                ]"
              >
                {{ i.label }}
              </span>
            </router-link>
          </v-list-item>
        </v-list-group>
        <external-link-dialog
            v-if="btnFields && btnFields.externalLink"
            :link="btnFields.externalLink"
            :dialog="dialog"
            @close="close"
        />
        <email-dialog
            v-if="btnFields && btnFields.type === ContentType.downloadGuide"
            v-model="downloadGuideModal"
            is-download
            @download="downloadAsset()"
        />
        <Submenu
          v-if="btnFields && btnFields.dropdownContent && !smAndDown"
          :content="btnFields.dropdownContent"
          :linkHover="isHover"
          :activeMenu="activeMenu"
          @open-dropdown="bubbleEvent"
        >
        </Submenu>
    </span>
</template>

<script>
import { mapState } from 'vuex'
import { backgroundColorClass } from '@/utils/helpers'
import ExternalLinkDialog from '@/components/dialogs/external-link-dialog'
import EmailDialog from '@/components/dialogs/email-dialog'
import BtnMixin, { ContentType } from '@/mixins/btn-mixin'
import Submenu from '@/components/core/submenu'

export default {
  name: 'CTFLink',
  components: {
    ExternalLinkDialog,
    EmailDialog,
    Submenu
  },
  mixins: [BtnMixin],
  props: {
    inverted: {
      type: Boolean,
      default: false
    },
    textLink: {
      type: Boolean,
      default: false
    },
    navLink: {
      type: Boolean,
      default: false
    },
    utilityNavLink: {
      type: Boolean,
      default: false
    },
    arrowLink: {
      type: Boolean,
      default: false
    },
    margin: {
      type: Boolean,
      default: true
    },
    activeMenu: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      ContentType,
      dialog: false,
      isHover: false
    }
  },
  computed: {
    ...mapState({ siteConfig: (state) => state.site.siteConfig }),
    smAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    },
    hoverClass () {
      if (!this.isHover) {
        return ''
      }
      return this.siteConfig.secondaryColor === 'dark blue'
        ? 'info--text'
        : 'secondary--text'
    },
    mobileClass () {
      if (!this.smAndDown) {
        return ''
      }
      return this.siteConfig.secondaryColor === 'dark blue'
        ? 'info--text'
        : 'secondary--text'
    }
  },
  methods: {
    backgroundColorClass,
    handleClick () {
      if (this.loading) {
        return
      }
      this.btnClick() // see BtnMixin
    },
    close () {
      this.dialog = false
    },
    bubbleEvent (model) {
      this.$emit('open-dropdown', model)
      // this method also exists in utility-nav-button.vue
      // https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
      const els = document.getElementsByClassName('dropdown-menu container')
      Array.prototype.forEach.call(els, el => {
        if (!this.isElementInViewport(el)) {
          el.style.right = 0
        } else {
          el.style.right = 'initial'
        }
      })
    },
    isElementInViewport (el) {
      el.style.right = 'initial' // check if its initial position is in viewport
      var rect = el.getBoundingClientRect()
      const isInviewPort = (
        rect.right <= (window.innerWidth || document.documentElement.clientWidth))
      return isInviewPort
    },
    replaceSpaceWithDash (str) {
      if (str !== null && str !== undefined) {
        return str.replace(/\s/g, '-').toLowerCase()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables';
.link {
    display: block;
    color: $white;
}

span {
    z-index: 250;
}

.base-button {
    z-index: 255;
}

.router-link-active-info {
    position: relative;
    color: $info !important;
    .primary--text {
        color: $info !important;
    }
    .info--text {
        color: $primary !important;
    }
}
.router-link-active-secondary {
    color: $secondary !important;
    .primary--text {
        color: $secondary !important;
    }
    .secondary--text {
        color: $primary !important;
    }
}
.sub-router-link {
  padding-left: 32px !important;
  color: $secondary !important;
    .primary--text {
        color: $secondary !important;
    }
    .secondary--text {
        color: $primary !important;
    }
}
.v-list-item {
    border: 1px solid transparent !important;
    &:focus {
        border: 1px solid $secondary !important;
    }
}
a {
    text-decoration: none;
}
.v-list-group {
  padding: 0px !important;
  @media only screen and (min-width:$breakpoint-xs) {
    margin-left: 8px;
  }
  @media only screen and (min-width:$breakpoint-sm) {
    margin-left: 16px;
  }
}
.ctf-utility-nav-link {
    position: relative;
}
.ctf-utility-nav-link:hover {
    text-decoration: underline !important;
}
.arrow-link-depth {
    z-index: 4;
}
</style>
